import { useEffect, useState } from 'react'

/**
 * Returns true when the viewport is below the `lg` breakpoint (1024px).
 *
 * Used by the layout to switch the sidebar between an in-flow column (desktop)
 * and an off-canvas overlay drawer (mobile/tablet).
 */
export function useIsMobile(breakpoint = 1024): boolean {
  const query = `(max-width: ${breakpoint - 1}px)`
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setIsMobile(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return isMobile
}
